import React, { useEffect, useRef, useState } from 'react';

export interface PayURedirectRequest {
  action: string;
  values: Record<string, string>;
}

export const usePayUCheckout = () => {
  const [request, setRequest] = useState<PayURedirectRequest | null>(null);
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (!request) return;
    const timer = window.setTimeout(() => formRef.current?.submit(), 100);
    return () => window.clearTimeout(timer);
  }, [request]);

  return { request, begin: setRequest, formRef };
};

export type PayUCheckout = ReturnType<typeof usePayUCheckout>;

interface PayURedirectFormProps {
  checkout: PayUCheckout;
}

const PayURedirectForm: React.FC<PayURedirectFormProps> = ({ checkout }) => {
  if (!checkout.request) return null;

  return (
    <form ref={checkout.formRef} method="POST" action={checkout.request.action} style={{ display: 'none' }}>
      {Object.entries(checkout.request.values).map(([name, value]) => (
        <input key={name} type="hidden" name={name} value={value} />
      ))}
    </form>
  );
};

export default PayURedirectForm;
